export default __webpack_public_path__ + "static/media/sc-overall.f1a07639.svg";